<template>
  <educational-unavailable v-if="$route.meta.blockStudents && $store.getters['auth/isStudent']" />
  <router-view v-else />
</template>

<script>
// Renders the educational-unavailable card instead of the actual route component
// when the route is flagged `meta.blockStudents` and the user is a student.
// Mounted once per layout slot in App.vue so the gate is centralized — adding
// a new layout doesn't require re-implementing the check.
export default {
  name: 'GatedRouterView',
};
</script>
